<template>
    <div class="comic-list-wrap clearfix">
        <div
            v-for="(item, index) in characterList"
            :key="index"
            :class="['comic-item', item.size, item.float]"
            @click="goChat(item.id)"
        >
            <img :src="item.avatar" alt="" class="comic-image">
            <div class="comic-info-wrap">
                <p class="comic-name">{{ item.name }}</p>
                <p v-if="item.size === 'large'" class="comic-desc">{{ item.description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    characterList() {
      return this.list.map((item, index) => {
        const mod = index % 6;
        return {
          ...item,
          size: [1, 2, 3, 5].includes(mod) ? 'small' : 'large',
          float: [0, 3, 5].includes(mod) ? 'left' : 'right',
        };
      });
    },
  },
  methods: {
    goChat(id) {
      this.$emit('goChat', id);
    },
  },
};
</script>

<style lang="less" scoped>
.comic-list-wrap {
    .comic-item {
        width: 215px;
        height: 250px;
        margin-bottom: 4px;
        overflow: hidden;
        position: relative;
        &.small {
            width: 109px;
            height: 123px;
            .comic-info-wrap  {
                padding: 6px 8px;
            }
        }
        &.left {
            float: left;
        }
        &.right {
            float: right;
        }
        .comic-image {
            width: 100%;
            height: 100%;
            vertical-align: middle;
        }
        .comic-info-wrap {
            font-family: Roboto;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 12px 12px 6px;
            background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            .comic-name {
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                color: @black;
                margin-bottom: 2px;
            }
            .comic-desc {
                font-size: 10px;
                line-height: 12px;
                font-weight: 400;
                color: @gray;
                .overflow-ellipsis(3);
            }
        }
    }

}

</style>
